import React, { useEffect, useState, useRef } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../elements/RenderErrors';
import InputTextArea from '../elements/InputTextArea';
import ButtonGroupSelection from '../elements/ButtonGroupSelection';
import store from '../../services/store';
import helpers from '../../services/helpers';
import { getApiData } from '../../services/apiService';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
 
export default function ContactMemberFormModal ({
        reference_id = '', 
        is_show = false, 
        setShow, 
        handleSave, 
        header_title="Customer Member",
        src="customer",
        store_id="",
        index="",
        member_data={},
        direct_save
    }){
    let default_data = {
        "id": "",
        "name":"",
        "relationship":"",
        "gender":"",
        "age":"",
        "flag":"new"
    }
    const toast = useRef(null);
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');
    const [record_data, setRecordData] = useState(default_data);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [errors, setErrors] = useState([]);
   
    useEffect(() => {
        setErrors([])
        
        if(src=="store" && is_show) {
            fetchData()
        }
        else if(is_show && member_data) {
            setRecordData(member_data)
            //fetchCities()
        }
        else{
            setRecordData(default_data)
            //fetchCities()
        }
    }, [is_show, member_data]);
   
    useEffect(() => {
        setErrors([])
    }, [record_data]);
    

    function fetchData(){
        if(!reference_id){
            return
        }
        const url = helpers.createUrl(`V1/manage/store/address/${reference_id}?store_id=${helpers.getStoreID()}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setRecordData(res)
            setLoading(0)
            setRecordLoaded(1)
        })
        .catch((err) => {
            setLoading(0)
            setRecordLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                }
            })
        }); 
    }
    
    function inputChange(e,) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        setRecordData({ ...record_data, ...new_state });
    }

    function validateForm(){
        let new_errors = {...errors}
        let variant_errors = 0;

        if(!record_data.name){
            new_errors['name'] = ['The name field is required.']
        }
        else{
            delete new_errors['name'];
        }

        if(!record_data.relationship){
            new_errors['relationship'] = ['The relationship field is required.']
        }
        else{
            delete new_errors['relationship'];
        }

        if(!record_data.gender){
            new_errors['gender'] = ['The gender field is required.']
        }
        else{
            delete new_errors['gender'];
        }

        console.log('age', record_data.age)
        if(record_data.age === null || record_data.age === undefined || record_data.age === ""){
            new_errors['age'] = ['The age field is required.']
        }
        else{
            delete new_errors['age'];
        }

        setErrors(new_errors);

        return new_errors;
    }

    function handleSubmit(e) {
        const validate = validateForm();
        if(Object.keys(validate).length){
            toast.current.show({severity:'error', detail:'Please complete all required fields in the form.', life: 5000});
            return
        }

        setShow(0);
        let form_data = {...record_data}
        if(reference_id){
            form_data.flag = 'edit'
        }

        handleSave(form_data, index)
        
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setRecordData([])
        setNotice('')
    }

    const footerContent = (
        <div>
            <Button label="Save" className='rounded' icon="fas fa-check" onClick={(e) => handleSubmit(1)} autoFocus />
        </div>
    );

    return (
        <>
            <Toast ref={toast} position="top-center" />
            <Dialog 
                visible={is_show} 
                position="top" 
                header={header_title} 
                style={{ width: '50vw' }} 
                breakpoints={{ 
                    '960px': '75vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                footer={footerContent}
            >
                <Loader isLoading={loading}/>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <label>Name<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="name" 
                                name="name" 
                                value={record_data.name}
                                tagClass="form-control mb-0"
                                placeholder="Name"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="name" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Relationship<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <Dropdown  
                                name='relationship'
                                value={record_data.relationship} 
                                onChange={(e) =>
                                    setRecordData(prev => ({
                                        ...prev,
                                        'relationship': e.value
                                    }))
                                } 
                                options={store.member_relationships} 
                                optionLabel="label" 
                                optionValue="id" 
                                placeholder="Select Relationship" 
                                className="w-100" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                filterInputAutoFocus={true}
                                appendTo="self"
                                showClear
                                filter 
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="relationship" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Gender<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <Dropdown  
                                name='gender'
                                value={record_data.gender} 
                                onChange={(e) =>
                                    setRecordData(prev => ({
                                        ...prev,
                                        'gender': e.value
                                    }))
                                } 
                                options={store.gender} 
                                optionLabel="label" 
                                optionValue="id" 
                                placeholder="Select Gender" 
                                className="w-100" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                filterInputAutoFocus={true}
                                appendTo="self"
                                showClear
                                filters
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="gender" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Age<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-12 col-md-3 form-group">
                            <InputNumber
                                id="age" 
                                name="age" 
                                value={record_data.age}
                                tagClass="form-control mb-0"
                                placeholder="Age"
                                onValueChange={inputChange}
                                min={0} 
                                max={999}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="age" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
            </Dialog>
        </>
    )
}